import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SideMenuService } from '../side-menu.service';

const DIRECT_ROUTE_STATES = [
  'dashboards', 'surveys', 'survey-analysis',
  'sentiment-analysis-2', 'sentiment-analysis', 'flagged-comments'
];

@Component({
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    selector: 'app-menu-item',
    standalone: false
})
export class MenuItemComponent implements OnInit, OnDestroy {
  @Input() menuItem: any;

  private manuallyOpened = new Set<string>();
  private subs: Subscription[] = [];

  constructor(private router: Router, private sideMenuService: SideMenuService) {}

  ngOnInit(): void {
    // Clear manually-opened states that no longer match the URL on navigation
    this.subs.push(
      this.router.events
        .pipe(filter(e => e instanceof NavigationEnd))
        .subscribe(() => {
          const segments = this.router.url.split('/');
          for (const state of Array.from(this.manuallyOpened)) {
            if (segments.indexOf(state) < 0) { this.manuallyOpened.delete(state); }
          }
        })
    );

    // Allow external callers (e.g. AdminLayoutComponent after views load) to
    // programmatically expand a level-2 section by state name.
    this.subs.push(
      this.sideMenuService.expand$.subscribe(state => this.manuallyOpened.add(state))
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  isExpanded(state: string): boolean {
    const segments = this.router.url.split('/');
    return segments.indexOf(String(state)) > 0 || this.manuallyOpened.has(state);
  }

  onPanelOpened(state: string): void { this.manuallyOpened.add(state); }
  onPanelClosed(state: string): void { this.manuallyOpened.delete(state); }

  /** Build the router link for a level-3 leaf item. */
  getSubChildRoute(childItem: any, subChildItem: any): any[] {
    const base = ['/', this.menuItem.state, childItem.state];
    const extra = subChildItem.additionalStates || [];
    const useDirect = DIRECT_ROUTE_STATES.includes(subChildItem.state)
      || this.menuItem.state === 'saved-user-filters';
    return useDirect
      ? [...base, subChildItem.state, ...extra]
      : [...base, 'dashboard', subChildItem.state, ...extra];
  }
}
